import EventTrackingProvider from "api/services/EventTracingProvider";
import { IMenuItems, MenuItemType } from "./MenuModel";
import { ProductsMajor } from "@shopify/polaris-icons";
const pricing: IMenuItems = {
  id: "pricing",
  type: MenuItemType.Group,
  title: "Pricing",
  url: "/pricing",
  icon: ProductsMajor,
  onAfterClickMenu: (shop) => {
    EventTrackingProvider.Track("pricing", shop);
  }
};

export default pricing;
